import { useCallback, useEffect, useState } from 'react';
import { GiPlainCircle } from 'react-icons/gi';
import { useNavigate, useParams } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import addjob from '../../css/style.module.css';

import img2 from '../../assest/loading1.gif';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDate } from '../../utils/utils';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const UserProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading2] = useState(false);
  const [cartCount, SetCartCount] = useState('');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    dateOfBirth: '',
    gender: '',
    businessName: '',
    bussinessType: '',
    businessDescription: '',
    businessStreet1: '',
    businessStreet2: '',
    businessTown: '',
    businessLandMark: '',
    businessCity: '',
    businessCountry: '',
    businessPostCode: '',
    businessNameOnPanCard: '',
    addressOnPanCard: '',
    upiId: '',
    bankName: '',
    bankAccountNumber: '',
    ifscCode: '',
    wallet: '',
    gstNo: '',
  });

  const [imagePreviews, setImagePreviews] = useState({
    image: '',
  });

  const fetchStaffData = useCallback(async () => {
    await getApi(endPoints.getStaffbyid(id), {
      setResponse: (response) => {
        const data = response?.data || {};
        setFormData({
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          phone: data.phone || '',
          email: data.email || '',
          dob: formatDate(data.dateOfBirth),
          businessName: data.businessName || '',
          bussinessType: data.bussinessType || '',
          businessDescription: data.businessDescription || '',
          businessNameOnPanCard: data.businessNameOnPanCard || '',
          gender: data.gender || '',
          addressOnPanCard: data.addressOnPanCard || '',
          upiId: data.upiId || '',
          wallet: data.wallet || '',
          businessStreet1: data.businessStreet1 || '',
          businessStreet2: data.businessStreet2 || '',
          businessTown: data.businessTown || '',
          businessLandMark: data.businessLandMark || '',
          businessCity: data.businessCity || '',
          businessCountry: data.businessCountry || '',
          businessPostCode: data.businessPostCode || '',
          bankName: data.bankName || '',
          bankAccountNumber: data.bankAccountNumber || '',
          ifscCode: data.ifscCode || '',
        });
        setImagePreviews({
          image: data.image || '',
        });
      },
      setLoading,
      errorMsg: 'Failed to fetch data!',
    });
  }, [id]);

  useEffect(() => {
    fetchStaffData();
  }, [fetchStaffData]);

  const fetchCartData = useCallback(async () => {
    await getApi(endPoints.getCartbyid(id), {
      setResponse: SetCartCount,
      setLoading: setLoading2,
      errorMsg: 'Failed to fetch cart data!',
    });
  }, [id]);

  useEffect(() => {
    fetchCartData();
  }, [fetchCartData]);

  const renderPopover = (
    <Popover id="popover-basic">
      <Popover.Body>
        {cartCount.msg === 'Cart retrieved successfully'
          ? 'Click to view cart details.'
          : 'Cart is currently empty.'}
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>User Profile</h6>
          </div>
          <div className={addjob.rightbuttons}>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={renderPopover}
            >
              <div
                className={addjob.rightbuttons2}
                onClick={() =>
                  cartCount.msg === 'Cart retrieved successfully' &&
                  navigate(`/user-management/create-order/cart/${id}`)
                }
                style={{
                  cursor:
                    cartCount.msg === 'Cart retrieved successfully' ? 'pointer' : 'not-allowed',
                  background: cartCount.msg === 'Cart retrieved successfully' ? '' : '#5A5A5A',
                }}
              >
                <p>User Cart</p>
                {cartCount.msg === 'Cart retrieved successfully' && <GiPlainCircle color="green" />}
              </div>
            </OverlayTrigger>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>User Details</h6>
            </div>
            {loading || loading1 ? (
              <div className={addjob.loadingnormal}>
                <img src={img2} alt="Loading" width={100} height={100} />
              </div>
            ) : (
              <>
                <div className={addjob.addcontactdetails}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      placeholder="Enter first name"
                      value={formData.firstName}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Last Name</label>
                    <input
                      type="text"
                      placeholder="Enter last name"
                      name="lastName"
                      value={formData.lastName}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Email</label>
                    <input
                      type="email"
                      placeholder="Enter email"
                      name="email"
                      value={formData.email}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Number</label>
                    <input
                      type="text"
                      placeholder="Enter number"
                      name="phone"
                      value={formData.phone}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Date Of Birth</label>
                    <input type="date" value={formData.dateOfBirth} name="dateOfBirth" />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Gender</label>
                    <input
                      type="text"
                      placeholder="Enter gender"
                      name="gender"
                      value={formData.gender}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Name</label>
                    <input
                      type="text"
                      placeholder="Enter the business name"
                      name="businessName"
                      value={formData.businessName}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">BussinessType</label>
                    <input
                      type="text"
                      placeholder="Enter the bussiness type"
                      name="bussinessType"
                      value={formData.bussinessType}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Description</label>
                    <input
                      type="text"
                      placeholder="Enter the business description"
                      name="businessDescription"
                      value={formData.businessDescription}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Street1</label>
                    <input
                      type="text"
                      placeholder="Enter the business street1"
                      name="businessStreet1"
                      value={formData.businessStreet1}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Street2</label>
                    <input
                      type="text"
                      placeholder="Enter the business street2"
                      name="businessStreet2"
                      value={formData.businessStreet2}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Town</label>
                    <input
                      type="text"
                      placeholder="Enter the business town"
                      name="businessTown"
                      value={formData.businessTown}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business LandMark</label>
                    <input
                      type="text"
                      placeholder="Enter the business landmark"
                      name="businessLandMark"
                      value={formData.businessLandMark}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business City</label>
                    <input
                      type="text"
                      placeholder="Enter the business city"
                      name="businessCity"
                      value={formData.businessCity}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Country</label>
                    <input
                      type="text"
                      placeholder="Enter the business country"
                      name="businessCountry"
                      value={formData.businessCountry}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business PostCode</label>
                    <input
                      type="text"
                      placeholder="Enter the business postcode"
                      name="businessPostCode"
                      value={formData.businessPostCode}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Name On PanCard</label>
                    <input
                      type="text"
                      placeholder="Enter the business name on panCard"
                      name="businessNameOnPanCard"
                      value={formData.businessNameOnPanCard}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Address On panCard</label>
                    <input
                      type="text"
                      placeholder="Enter the address on panCard"
                      name="addressOnPanCard"
                      value={formData.addressOnPanCard}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">UPI Id</label>
                    <input
                      type="number"
                      placeholder="Enter the to upiId"
                      name="upiId"
                      value={formData.upiId}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Bank Name</label>
                    <input
                      type="text"
                      placeholder="Enter the bank name"
                      name="bankName"
                      value={formData.bankName}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Bank Account Number</label>
                    <input
                      type="text"
                      placeholder="Enter the bank account number"
                      name="bankAccountNumber"
                      value={formData.bankAccountNumber}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">IFSC Code</label>
                    <input
                      type="text"
                      placeholder="Enter the IFSC Code"
                      name="ifscCode"
                      value={formData.ifscCode}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">GST No</label>
                    <input
                      type="text"
                      placeholder="Enter the gstNo"
                      name="gstNo"
                      value={formData.gstNo}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Wallet</label>
                    <input
                      type="text"
                      placeholder="Enter the wallet"
                      name="wallet"
                      value={formData.wallet}
                    />
                  </div>
                </div>
                <div className={addjob.addjobtopic}>
                  <h6>Profile Image</h6>
                </div>
                <div className={addjob.addcontactdetails}>
                  <ImageUpload
                    label="Profile Image*"
                    name="image"
                    imagePreview={imagePreviews.image}
                    clear="dahd"
                  />
                </div>
              </>
            )}
          </div>

          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(UserProfile);
